import moment from 'moment';
import React, { Component } from "react";
import {format_display_DDMMYYYY} from './Utils';
import {Modal, Table} from 'react-bootstrap';
import { ReportService } from './Services/ReportService';

export default class TransactionDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            detailed: [],
            detailedRow: [],
            show: true,
            modalTitle: this.props.report.product,
            report : this.props.report,
            agent_id: this.props.agent_id,
            startDate: this.props.startDate,
            endDate: this.props.endDate
        }

        this.viewTransactions = this.viewTransactions.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
      }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            detailed: [],
            detailedRow: []
        });
    }

    handleShow() {
        this.setState({ show: true });
    }

    componentDidMount(){
        this.viewTransactions(this.state.report);
    }

    viewTransactions(report){
        console.log(report);
        let detailedRow = [];
        ReportService.getAgentTransactionDetailsMismatch(this.state.report.route_id, this.state.agent_id, this.state.startDate, this.state.endDate, this.state.report.product_id)
        .then((data) => {
            console.log(data.report);
            data.report.forEach((report, index) => {
                detailedRow.push(
                    <TransactionDetailsRows key={index} report={report}/>
                );
            });
            this.setState({
                detailed: data.report,
                detailedRow
            });
            this.handleShow();
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    render() {
        return (
            <Modal show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.show ? this.state.modalTitle : ""}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped condensed hover responsive>
                        <thead>
                            <tr>
                                <th>Scheduled Date</th>
                                <th>Route</th>
                                <th>Customer</th>
                                <th>Actual Count</th>
                                <th>Delivered Count</th>
                                <th>Agent</th>
                            </tr>
                        </thead>
                        <tbody style={{textAlign: "left"}}>
                            {this.state.detailedRow}
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>
        );
    }
}

class TransactionDetailsRows extends Component {

    render(){
        const report = this.props.report;
        return (
            <tr>
                <td>{moment(report.schedule_date).format(format_display_DDMMYYYY)}</td>
                <td>{report.route_id}</td>
                <td>{report.customer_name}</td>
                <td>{report.actual_count}</td>
                <td>{report.delivered_count}</td>
                <td>{report.agent_name ? report.agent_name: "-"}</td>
            </tr>
        );
    }
}